// extracted by mini-css-extract-plugin
export default {"SkillsFilter":"SkillsFilter_SkillsFilter__fWU87","activeSkill":"SkillsFilter_activeSkill__2nP6s"};